<template>
<div class="ui card">
  <div class="content" v-for="sectionName in sectionNames">
    <slot :name="sectionName"></slot>
  </div>
</div>
</template>

<script>
export default {
  name: 'card',
  data() {
    return {
      sectionNames: ["header", "meta", "list", "labels"]
    }
  },
  props: ["items"]
}
</script>



// WEBPACK FOOTER //
// src/components/Card.vue